<template>
    <div>
        <div class="homeLogin" v-if="!isMobile">
            <div class="slogan">
                <fillBgBox :bgImg="bgList[0]">
                    <h5>{{ langPage['v4-home-not-connected']['TXT_slogen'].trim() }}</h5>
                </fillBgBox>
            </div>
            <div class="banner">
                <!-- <swiper :options="bannerOpt" ref="banner" v-if="bannerList.length">
                    <swiper-slide v-for="(item,i) in bannerList" :key="i">
                        <fillBgBox :bgImg="item.imgUrl"></fillBgBox>
                    </swiper-slide>
                </swiper> -->
                <el-carousel height="600px" ref="carousel">
                    <!--                         :interval="5000" -->
                    <!--                         arrow="never" -->
                    <!--                         indicator-position="none"-->
                    <!--                         :loop="false"-->
                    <!--                         :autoplay="false" -->
                    <el-carousel-item v-for="(item,i) in bannerList" :key="i" :name="i.toString()">
                        <fillBgBox :bgImg="item.imgUrl" :img-data="item">
                            <!--                        <div class="toShop">-->
                            <!--                            &lt;!&ndash; <img src="../assets/img/home/logo-Marque.svg" alt=""> &ndash;&gt;-->
                            <!--                            <div class="toShop-logo">-->

                            <!--                            </div>-->
                            <!--                            <p>Découvrez la</p>-->
                            <!--                            <p>collection hiver</p>-->
                            <!--                            <div class="toShop-btn" @click="toMarques">-->
                            <!--                                <span>Shop</span>-->
                            <!--                            </div>-->
                            <!--                        </div>-->
                        </fillBgBox>
                    </el-carousel-item>
                </el-carousel>

                <!--            <div class="pagination">-->
                <!--                <div class="dotBox" v-for="(dot,dotIdx) in bannerList" :key="'dot'+dotIdx">-->
                <!--                    <div :class="{dot:true,act:dotIdx == btnLine}"></div>-->
                <!--                </div>-->
                <!--            </div>-->
                <!--            <div class="logoBtns">-->
                <!--                <div class="logo" v-for="(logo,logoIdx) in logoList" @click="logoChange(logoIdx)" :key="'logo'+logoIdx"-->
                <!--                     ref="btnItems">-->
                <!--                    <img :src="logo" alt="">-->
                <!--                </div>-->
                <!--            </div>-->
            </div>
            <h3 style="margin-top:30px">{{ langPage['v4-homelogin']['TXT_categoriesselection'] }}</h3>
            <div class="recommend">
                <div class="fliter">
                    <el-collapse v-model="activeName" accordion>
                        <el-collapse-item v-for="(filter,fIndex) in filterList" :title="filter.name.toUpperCase()"
                                          :name="fIndex"
                                          :key="fIndex">
                            <div v-for="(subList,subIndex) in filter.list" :key="subIndex">
                                <div class="fils" :class="{'out-line':activeText === subitem.libelle}"
                                     v-for="(subitem,subitemIndex) in subList.categories_langues" :key="subitemIndex"
                                     @click="selCategories(subitem)">{{ subitem.libelle }}
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="goods" v-loading="isLoadingNewProduction">
                    <goodsList @goDetail='goDetail' :list="newList" type="0" :rows="4"></goodsList>
                    <div class="btnLine">
                        <div v-if="newList.length==0" class="noProdHint">{{ langPage['catalogue-liste']['TXT_aucunresultat'] }}</div>
                        <div class="whiteBtn" @click="loadGoodNew">
                            {{ langPage['compte-commandes-liste']['TXT_voirplus'] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="saleBox">
                <fillBgBox :bgImg="imgs.bg06">
                    <div class="content">
                        <h3 v-if="!config_system[`homelogin_discount_desc_${langue}`]">
                            -15% sur les frais de port <br> de votre 1ère commande.</h3>
                        <h3 v-else>{{ config_system[`homelogin_discount_desc_${langue}`] }}</h3>
                        <div class="whiteBtn">{{
                                config_system.homelogin_discount_code ? config_system.homelogin_discount_code : $t("homeLogin.word1")
                            }}
                        </div>
                        <!--                        <div class="tip">*Valable pour toutes commande de plus de 100€</div>-->
                    </div>
                </fillBgBox>
            </div>
            <div class="sellWell">
                <div class="title">
                    <h3>{{ langPage['home']['TXT_bestseller'] }}</h3>
                    <div class="tip" @click="$router.push('/sellWellProductList')">
                        {{ langPage['compte-commandes-liste']['TXT_voirplus'] }}
                    </div>
                </div>
                <goodsList @goDetail='goDetail' :list="bestList" goods-list-img-class="homeLoginGoodsListImgSellWell"
                           type="0" :rows="4" :margin-right="'32px'"></goodsList>
            </div>
            <div class="classify">
                <h3>{{ langPage['sitemaps']['TXT_categories'] }}</h3>
                <div class="list">
                    <router-link :to="`/productList?id=${$store.state.fast_categoryId}&is_new_productions=true`"
                                 class="nav">
                        <img :src="imgs[`${topCategoryNameEn}Rectangle20`]" alt="">
                        <div class="name">{{ langPage['v4-topmenu']['TXT_nouveautes'] | toUpperCase }}</div>
                        <div class="num">{{ `${productionStatistic.newPro} articles` }}</div>
                    </router-link>
                    <router-link :to="`/productList?id=${$store.state.fast_categoryId}`" class="nav">
                        <img :src="imgs[`${topCategoryNameEn}Rectangle27`]" alt="">
                        <div class="name">{{ langPage['menu-header']['TXT_vetements'] | toUpperCase }}</div>
                        <div class="num">{{ `${productionStatistic.man} articles` }}</div>
                    </router-link>
                    <router-link to="/productList?id=1401" class="nav">
                        <img :src="imgs[`${topCategoryNameEn}Rectangle28`]" alt="">
                        <div class="name">
                            {{ langPage['boa-communication-seocategories']['TXT_chaussures'] | toUpperCase }}
                        </div>
                        <div class="num">{{ `${productionStatistic.shoes} articles` }}</div>
                    </router-link>
                    <router-link to="/productList?id=15" class="nav">
                        <img :src="imgs[`${topCategoryNameEn}Rectangle29`]" alt="">
                        <div class="name">{{ langPage['v4-home-not-connected']['TXT_sacs'] | toUpperCase }}</div>
                        <div class="num">{{ `${productionStatistic.packet} articles` }}</div>
                    </router-link>
                    <router-link to="/productList?id=16" class="nav">
                        <img :src="imgs[`${topCategoryNameEn}Rectangle30`]" alt="">
                        <div class="name">{{ langPage['sidemenu']['TXT_accessoires'] | toUpperCase }}</div>
                        <div class="num">{{ `${productionStatistic.decoration} articles` }}</div>
                    </router-link>
                </div>

            </div>
            <div class="ins">
                <div class="title">
                    <h3>{{ langPage['v4-home-not-connected']['TXT_suivezinstagram'] }}</h3>
                    <div class="whiteBtn" @click="jumpToInstagram">@efashionparis_official</div>
                </div>
                <ul class="images1 infinite-list-wrapper">
                    <li class="nav" v-for="(item,index) in instagramProds" :key="index">
                        <img :src=item.display_url_us alt="" @click="jumpToInstagram"/>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mHomeLogin mobileCommon" v-if="isMobile">
            <el-row class="slogan" type="flex" align="middle">
                <img class="topDescBg" src="../assets/img/mobile/bg04.svg" alt=""/>
                <div class="topDesc">
                    {{ langPage['v4-home-not-connected']['TXT_slogen'] }}
                </div>
            </el-row>
            <div class="banner">
                <el-carousel ref="carousel" style="height: 90vw">
                    <el-carousel-item v-for="(item,i) in bannerList" :key="i" :name="i.toString()" style="height: 90vw">
                        <fillBgBox :bgImg="item.imgUrl" :img-data="item" style="height: 20vw">
                        </fillBgBox>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <h3 style="margin-top:30px;">{{ langPage['v4-homelogin']['TXT_categoriesselection'] }}</h3>
            <div class="recommend">
                <div class="fliter ">
                    <el-collapse accordion class="topMenuCollapse">
                        <el-collapse-item :title="langPage['menu-header']['TXT_vetements']">
                            <el-collapse v-model="activeName" accordion>
                                <el-collapse-item v-for="(filter,fIndex) in filterList" :title="filter.name"
                                                  :name="fIndex"
                                                  :key="fIndex">
                                    <div v-for="(subList,subIndex) in filter.list" :key="subIndex">
                                        <div class="fils" :class="{'out-line':activeText === subitem.libelle}"
                                             v-for="(subitem,subitemIndex) in subList.categories_langues"
                                             :key="subitemIndex"
                                             @click="selCategories(subitem)">{{ subitem.libelle }}
                                        </div>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="goods" v-loading="isLoadingNewProduction">
                    <goodsList @goDetail='goDetail' :list="newList" type="0"></goodsList>
                    <div class="btnLine">
                        <div v-if="newList.length==0" class="noProdHint">{{ langPage['catalogue-liste']['TXT_aucunresultat'] }}</div>
                        <div class="whiteBtn" @click="loadGoodNew">
                            {{ langPage['compte-commandes-liste']['TXT_voirplus'] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="saleBox">
                <fillBgBox :bgImg="imgs.mbg05">
                    <div class="content">
                        <h3 v-if="!config_system[`homelogin_discount_desc_${langue}`]">
                            -15% sur les frais de port <br> de votre 1ère commande.</h3>
                        <h3 v-else>{{ config_system[`homelogin_discount_desc_${langue}`] }}</h3>
                        <div class="whiteBtn">{{
                                config_system.homelogin_discount_code ? config_system.homelogin_discount_code : $t("homeLogin.word1")
                            }}
                        </div>
                        <!--                        <div class="tip">*Valable pour toutes commande de plus de 100€</div>-->
                    </div>
                </fillBgBox>
            </div>
            <div class="sellWell">
                <div class="title">
                    <h3>{{ langPage['home']['TXT_bestseller'] }}</h3>
                </div>
                <goodsList @goDetail='goDetail' :list="bestList"
                           type="0"></goodsList>
                <div class="tip" align="center" @click="$router.push('/sellWellProductList')">
                    {{ langPage['compte-commandes-liste']['TXT_voirplus'] }}
                </div>
            </div>
            <div class="classify">
                <h3>{{ langPage['sitemaps']['TXT_categories'] }}</h3>
                <ul class="list">
                    <router-link :to="`/productList?id=${$store.state.fast_categoryId}&is_new_productions=true`"
                                 class="nav">
                        <img :src="imgs[`${topCategoryNameEn}Rectangle20`]" alt="">
                        <div class="name">{{ langPage['v4-topmenu']['TXT_nouveautes'] | toUpperCase }}</div>
                        <div class="num">{{ `${productionStatistic.newPro} articles` }}</div>
                    </router-link>
                    <router-link :to="`/productList?id=${$store.state.fast_categoryId}`" class="nav">
                        <img :src="imgs[`${topCategoryNameEn}Rectangle27`]" alt="">
                        <div class="name">{{ langPage['menu-header']['TXT_vetements'] | toUpperCase }}</div>
                        <div class="num">{{ `${productionStatistic.man} articles` }}</div>
                    </router-link>
                    <router-link to="/productList?id=1401" class="nav">
                        <img :src="imgs[`${topCategoryNameEn}Rectangle28`]" alt="">
                        <div class="name">
                            {{ langPage['boa-communication-seocategories']['TXT_chaussures'] | toUpperCase }}
                        </div>
                        <div class="num">{{ `${productionStatistic.shoes} articles` }}</div>
                    </router-link>
                    <router-link to="/productList?id=15" class="nav">
                        <img :src="imgs[`${topCategoryNameEn}Rectangle29`]" alt="">
                        <div class="name">{{ langPage['v4-home-not-connected']['TXT_sacs'] | toUpperCase }}</div>
                        <div class="num">{{ `${productionStatistic.packet} articles` }}</div>
                    </router-link>
                    <router-link to="/productList?id=16" class="nav">
                        <img :src="imgs[`${topCategoryNameEn}Rectangle30`]" alt="">
                        <div class="name">{{ langPage['sidemenu']['TXT_accessoires'] | toUpperCase }}</div>
                        <div class="num">{{ `${productionStatistic.decoration} articles` }}</div>
                    </router-link>
                </ul>

            </div>
            <div class="ins">
                <div class="title">
                    <h3>{{ langPage['v4-home-not-connected']['TXT_suivezinstagram'] }}</h3>
                    <div class="whiteBtn" @click="jumpToInstagram">@efashionparis_official</div>
                </div>
                <ul class="list infinite-list-wrapper">
                    <li class="nav" v-for="(item,index) in instagramProds" :key="index">
                        <img :src=item.display_url_us alt="" @click="jumpToInstagram"/>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import fillBgBox from "../components/fillBgBox";
import goodsList from "../components/goodsList";
import bottomNav from "../components/bottomNav";

let loginHelper = require('@/utils/helper/Login/login_helper');
let commonUtils = require('@/utils/common_utils');

export default {
    name: "homeLogin",
    metaInfo() {
        let that = this;
        return commonUtils.getRichSnippetComplement(that, 'home');
    },
    components: {
        fillBgBox,
        goodsList,
        bottomNav,
    },
    filters: {
        toUpperCase(val) {
            if (!val) return "";
            return val.toUpperCase();
        }
    },
    computed: {
        swipers() {
            return this.$refs.banner.swiper
        },
        langPage() {
            return this.$store.state.langPage
        },
        //最顶级的菜单英文名字  woman man child
        topCategoryNameEn() {
            let topId = this.$store.state.fast_categoryId;
            switch (topId) {
                case 12:
                    return 'man';
                case 13:
                    return 'child';
                default:
                    return 'woman';
            }
        }
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            activeText: '',
            langue: '',
            btnLine: 0,
            idCategorie: '',
            isToCatPara: 11,
            BestsPara: 11,
            goodNewForm: {
                page: 1,
                pageSize: 8
            },
            goodBestsForm: {
                page: 1,
                pageSize: 8
            },
            goodNewtotal: 0,
            Beststotal: 0,
            bgList: [
                require('../assets/img/home/bg04.svg'),
            ],
            imgs: {
                bg06: require('../assets/img/home/bg06.png'),
                mbg05: require('../assets/img/home/mbg05.png'),
                womanRectangle20: require('../assets/img/home/Rectangle 20.png'),
                womanRectangle27: require('../assets/img/home/Rectangle 27.png'),
                womanRectangle28: require('../assets/img/home/Rectangle 28.png'),
                womanRectangle29: require('../assets/img/home/Rectangle 29.png'),
                womanRectangle30: require('../assets/img/home/Rectangle 30.png'),
                manRectangle20: require('../assets/img/home/Rectangle 20.png'),
                manRectangle27: require('../assets/img/home/Rectangle 27.png'),
                manRectangle28: require('../assets/img/home/Rectangle 28.png'),
                manRectangle29: require('../assets/img/home/Rectangle 29.png'),
                manRectangle30: require('../assets/img/home/Rectangle 30.png'),
                childRectangle20: require('../assets/img/home/Rectangle 20.png'),
                childRectangle27: require('../assets/img/home/Rectangle 27.png'),
                childRectangle28: require('../assets/img/home/Rectangle 28.png'),
                childRectangle29: require('../assets/img/home/Rectangle 29.png'),
                childRectangle30: require('../assets/img/home/Rectangle 30.png'),
            },
            bannerList: [],
            // bannerOpt: {
            //     // effect : 'fade',
            //     direction:'horizontal',
            //     observer:true,
            //     on: {
            //         click() {
            //             const { realIndex } = this;
            //             console.log(realIndex)
            //             // _this.handleClickSlide(realIndex);
            //         },
            //     },
            // },
            logoList: [
                require('../assets/img/home/Marque.png'),
                require('../assets/img/home/Marque-1.png'),
                require('../assets/img/home/Marque-2.png'),
                require('../assets/img/home/Marque-3.png'),
                require('../assets/img/home/Marque-4.png'),
                require('../assets/img/home/Marque-5.png'),
            ],
            bannerIdx: 0,
            activeName: '0',
            productionStatistic: {
                newPro: 100,
                woman: 100,
                man: 100,
                packet: 100,
                shoes: 100,
                decoration: 100,
                seller: 100,
            },
            filterList: [
                {
                    name: this.$langPage['sidemenu']['TXT_vetements'],
                    list: []
                },
                {
                    name: this.$langPage['sidemenu']['TXT_accessoire_chaussures'],
                    list: []
                },
                {
                    name: this.$langPage['sidemenu']['TXT_accessoire_maroquineries'],
                    list: []
                },
                {
                    name: this.$langPage['sidemenu']['TXT_accessoires'],
                    list: []
                }
            ],
            list: [
                {
                    url:
                        "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=3195767574,3213547618&fm=11&gp=0.jpg"
                },
                {
                    url:
                        "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=3195767574,3213547618&fm=11&gp=0.jpg"
                },
                {
                    url:
                        "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=3195767574,3213547618&fm=11&gp=0.jpg"
                },
                {
                    url:
                        "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=3195767574,3213547618&fm=11&gp=0.jpg"
                },
                {
                    url:
                        "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=3195767574,3213547618&fm=11&gp=0.jpg"
                }
            ],
            newList: [],
            bestList: [],
            isLoadingNewProduction: false,
            tempBannerJumpUrls: [
                '/productList?tendances=93',
            ],
            client_imgs: this.$store.state.client_page_imgs.homeLogin,
            config_system: this.$store.state.config_system,
            instagramProds: [],
            // typeList:[],
        }
    },
    created() {
        this.init()
        this.bannerList = [
            {
                id: '001',
                imgUrl: null,
                jumpUrl: this.tempBannerJumpUrls[0],
            },
        ]
    },
    mounted() {
        console.log('config_system', this.config_system)
        // this.$api.good.goodGetByType({pageSize:8},1101).then(data=>{
        //     console.log(data)
        //     this.typeList = data.results
        // })

        // this.$api.good.getType({id_langue:'fr',id_categorie:11}).then(data=>{
        //     console.log(data)
        // })
        this.getProductionStatistic();
        this.get_home_banner_list();
        this.replaceClientImgs();
        this.get_instagram_prods();
    },
    methods: {
        // changes() {
        //     this.bannerIdx = this.$refs.banner.swiper.activeIndex
        // },
        goDetail(item) {
            let url = window.origin + `/ProductDetail?id=${item.id_produit}&vendu_par=${item.vendu_par}&vid=${item.id_vendeur}&categorie_id=${item.id_categorie}`
            window.open(url, '_blank');
        },
        init() {
            loginHelper.old_station_connect_login(this);
            this.langue = localStorage.getItem('lang') || 'fr'
            this.getPList({id_langue: this.langue, id_categorie: this.$store.state.fast_categoryId})
            this.getPList({id_langue: this.langue, id_categorie: 14})
            this.getPList({id_langue: this.langue, id_categorie: 15})
            this.getPList({id_langue: this.langue, id_categorie: 16})
            this.goodBests()
        },
        loadGoodNew() {
            this.$router.push({
                name: 'ProductList',
                params: {id: this.isToCatPara},
                query: {categories: this.idCategorie, is_new_productions: true}
            })
            // let total = this.goodNewForm.page * this.goodNewForm.pageSize
            // if(total>=this.goodNewtotal) return
            // this.goodNewForm.page++
            // this.goodNewGets(this.idCategorie)
        },
        goodNewGets(para) {
            if (!para) para = this.$store.state.fast_categoryId;
            let data = {
                id_langue: localStorage.getItem('lang'),
                page: this.goodNewForm.page,
                pageSize: this.goodNewForm.pageSize,
                id_categorie: para
            }
            this.isLoadingNewProduction = true;
            this.$api.good.goodNewGet(data).then(data => {
                this.isLoadingNewProduction = false;
                let list = data.data.list
                list.forEach(item => {
                    item.url = `${this.$common.imgHost}Images/Boutiques/${item.id_vendeur}/Produits/fiche/${item.id_produit}-c.jpg`
                    // item.produit_liee = item.cp
                })
                this.newList = data.data.list
                // if (this.goodNewForm.page>1) {
                //      this.newList = this.newList.concat(data.data.list)
                // } else {
                //     this.newList = data.data.list
                // }
                // this.goodNewtotal = data.data.page.total
                // console.log(this.newList)
            })
        },
        goodBests() {
            let data = {
                id_langue: localStorage.getItem('lang'),
                page: this.goodBestsForm.page,
                pageSize: this.goodBestsForm.pageSize,
                id_parent_categorie: this.$store.state.fast_categoryId,
            }
            this.$api.good.goodBest(data).then(data => {
                let list = data.data.list
                list.forEach(item => {
                    item.url = `${this.$common.imgHost}Images/Boutiques/${item.id_vendeur}/Produits/fiche/${item.id_produit}-c.jpg`
                    // item.produit_liee = item.cp
                })
                this.bestList = data.data.list
                // if (this.goodBestsForm.page>1) {
                //      this.bestList = this.bestList.concat(data.data.list)
                // } else {
                //     this.bestList = data.data.list
                // }
                // this.Beststotal = data.data.page.total
            })
        },
        selCategories(data) {
            // console.log(data)
            if (data) {
                this.activeText = data.libelle
                let id = Number(data.id_categorie.toString().substring(0, 2))
                if (this.idCategorie == data.id_categorie) return
                this.idCategorie = data.id_categorie
                this.goodNewForm.page = 1
                this.goodNewForm.pageSize = 8
                this.isToCatPara = id
                this.goodNewGets(this.idCategorie)
            }
            // console.log(data)
        },
        logoChange(i) {
            this.$refs.carousel.setActiveItem(i)
            this.btnLine = i
            // this.swipers.slideTo(i)
        },
        getPList(para) {
            this.$api.good.getCategories({id_langue: para.id_langue}, para.id_categorie).then(data => {
                // console.log(data)
                let temp = [];
                for (let item of data.result.subcategories) {
                    if (item.supprimer != 1) {
                        temp.push(item);
                    }
                }
                data.result.subcategories = temp;
                this.goodNewGets();
                switch (data.result.id_categorie) {
                    case 11:
                    case 12:
                    case 13:
                        this.filterList[0].list = data.result.subcategories
                        this.activeText = data.result.subcategories[0].categories_langues[0].libelle
                        this.idCategorie = data.result.id_categorie
                        break;
                    case 14:
                        this.filterList[1].list = data.result.subcategories
                        break;
                    case 15:
                        this.filterList[2].list = data.result.subcategories
                        break;
                    case 16:
                        // this.filterList[3].list = data.result.subcategories;
                        //由于要把1605的男装分类，放到1604的分类前面，所以需要这样。
                        let tempArr = [];
                        let obj1604;//其他分类
                        let obj1605;//男装分类
                        for (let item of data.result.subcategories) {
                            if (item.id_categorie == '1604') {
                                obj1604 = item;
                            } else if (item.id_categorie == '1605') {
                                obj1605 = item;
                            } else {
                                tempArr.push(item);
                            }
                        }
                        tempArr.push(obj1605);
                        tempArr.push(obj1604);
                        this.filterList[3].list = tempArr;
                        break;
                }
            })
        },
        toMarques() {
            this.$router.push({name: ''})
        },
        getProductionStatistic() {
            this.$api.home.getProductionStatistic().then(res => {
                if (res.code !== 0) {
                    return console.log(res.message);
                }
                this.productionStatistic = res.data;
            })
        },
        get_home_banner_list() {
            let that = this;
            this.$api.home.get_home_banner_list({id_categorie: this.$store.state.fast_categoryId}).then(res => {
                if (res.code === 0) {
                    this.bannerList = [];
                    res.data.forEach((obj, index) => {
                        if (this.isMobile) {
                            let url = obj.imgUrl;
                            let tempUrl0 = url.substring(0, url.lastIndexOf('_'));
                            let tempUrl1 = url.substring(url.lastIndexOf('_'));
                            //往两个图片url中间插入一个_responsive表示移动端的图片地址
                            obj.imgUrl = tempUrl0 + `_responsive` + tempUrl1;
                        }
                        let item = {imgUrl: obj.imgUrl};
                        //https://www.efashion-paris.com/it/catalogo-tendenza/donna-selezionerosa-97.html
                        let url = obj.mod_bannieres_langue.lien;
                        //有catalogue表示是趋势，其他的直接使用
                        if (url.includes('catalogue')) {
                            url = url.substring(url.lastIndexOf('-'));
                            let id_tendance = commonUtils.getCenterStr(url, '-', '.html');
                            item.jumpUrl = `/productList?tendances=${id_tendance}`;
                        } else if (url.includes('/page/')) {//是页面类型的活动
                            //https://www.efashion-paris.com/page/soldes-dete-2021-266.html
                            url = commonUtils.getCenterStr(url, '/', '.html');
                            url = url.split('-');
                            let id_campagne = url[url.length - 1];
                            item.jumpUrl = `/campagne?id_campagne=${id_campagne}`;
                        } else {
                            item.jumpUrl = url;
                        }

                        this.bannerList.push(item);
                    })
                    if (commonUtils.isEmpty(this.bannerList)) {
                        this.bannerList.push({
                            id: '001',
                            imgUrl: require("../assets/img/home/bg05.svg"),
                            jumpUrl: this.tempBannerJumpUrls[0],
                        },)
                    }
                }
            })
        },
        //替换客户端图片
        replaceClientImgs() {
            console.log('client_imgs', this.client_imgs,)
            let clientImgs = this.client_imgs;
            if (Object.keys(clientImgs).length == 0) return;
            for (let key of Object.keys(this.imgs)) {
                this.imgs[key] = clientImgs[key].file_url;
            }
            console.log('client_imgs2', this.imgs)
            this.$forceUpdate();
        },
        get_instagram_prods() {
            this.$api.home.get_instagram_prods().then(res => {
                if (res.code != 0) return;
                this.instagramProds = [];
                for (let item of res.data) {
                    this.instagramProds.push(item.node)
                }
            })
        },
        jumpToInstagram() {
            window.open('https://www.instagram.com/efashionparis_official/', '_blank');
        },
    },

}
</script>

<style lang="less" scoped src="@/assets/viewCss/views/HomeLogin.less">
</style>

<style lang="less">
.homeLoginGoodsListImgCategory {
    width: 220px;
    height: 336px;
}

.homeLoginGoodsListImgSellWell {
    width: 300px;
    height: 456px;
}
</style>
